"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FDICResponse = void 0;
class FDICResponse {
    constructor() {
        this.desktop = {
            footer: { isEnabled: false },
            header: { isEnabled: false },
            login: { isEnabled: false },
        };
        this.mobile = {
            footer: { isEnabled: false },
            login: {
                isEnabled: false,
                signColor: 'DEFAULT',
            },
        };
        this.pages = { isEnabled: false };
    }
    update(config) {
        var _a, _b, _c;
        this.desktop = (_a = config.desktop) !== null && _a !== void 0 ? _a : this.desktop;
        this.mobile = (_b = config.mobile) !== null && _b !== void 0 ? _b : this.mobile;
        this.pages = (_c = config.pages) !== null && _c !== void 0 ? _c : this.pages;
    }
}
exports.FDICResponse = FDICResponse;
